import { Component, EventEmitter, Output, OnInit, Input, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { Region } from 'shared-lib';
import { Area } from '../../../models/area.model';
import { AreaService } from 'shared-lib';
import { RegionService } from 'shared-lib';
import { ToastrService } from 'ngx-toastr';
import { ValueChangeEvent } from '@angular/forms';
import { DateType, MvPoleAppliedFilter, MvPoleFilter, SortByOptions, UserType } from 'shared-lib';
import { User } from 'shared-lib';
import { SortType } from 'shared-lib';
import { UserService } from 'shared-lib';
import { SystemComponents } from 'shared-lib';
import { AuthService } from 'shared-lib';
import { GeographicalRegion, GeographicalRegionService, SubGeographicalRegion, SubGeographicalRegionService } from 'shared-lib';

@Component({
  selector: 'app-mv-pole-filter-window',
  templateUrl: './mv-pole-filter-window.component.html',
  styleUrl: './mv-pole-filter-window.component.scss',
  standalone: false
})
export class MvPoleFilterWindowComponent implements OnInit, OnChanges {

  constructor(
    private regionService: RegionService,
    private areaService: AreaService,
    private toastr: ToastrService,
    private userService: UserService,
    private cdr: ChangeDetectorRef,
    private authService: AuthService,
    private geographicalRegionService: GeographicalRegionService,
    private subGeographicalRegionService: SubGeographicalRegionService
  ) {
    this.hasCimDataIntegration = this.authService.hasCimDataIntegration;
  }

  hasCimDataIntegration: boolean = false;
  geographicalRegions: GeographicalRegion[] = [];
  allSubGeographicalRegions: SubGeographicalRegion[] = [];
  subGeographicalRegions: SubGeographicalRegion[] = [];
  selectedGeographicalRegion: GeographicalRegion | null = null;
  selectedSubGeoRegions: {id: number, name: string}[] = [];


  dateTypes = ['Last Update Time', 'Tagged Date', 'Validated Date'];
  selectedDateTypeString = this.dateTypes[0];
  selectedDateType: DateType = DateType.LastUpdateTime;
  selectedMonth = '';
  selectedYear = new Date().getFullYear();
  selectedDateFrom: string | null = null;
  selectedDateTo: string | null = null;
  regions: Region[] = [];
  areas: Area[] = [];
  allAreas: Area[] = [];
  regionSearchText: string = '';
  districtSearchText: string = '';
  openedFilters: string[] = [];
  selectedRegion: Region | null = null;
  selectedUserType: string | null = null;
  selectedPoleType: string | null = null
  selectedPoleCondition: string | null = null;
  selectedValidationStatus: string | null = null;
  selectedAreas: {id: number, name: string}[] = [];
  filter: MvPoleFilter = new MvPoleFilter();
  appliedFilters: MvPoleAppliedFilter[] = [];

  searchUsersText: string = '';
  allUsers: {id: number, name: string}[] = [];

  selectedUsers: {id: number, name: string}[] = [];

  userTypes = [
    { label: 'First_Captured', value: 'first' },
    { label: 'Last_Captured', value: 'last' },
    { label: 'Reassigned', value: 'reassigned' },
    { label: 'Validated', value: 'validated' },
    { label: 'Audited', value: 'audited' }
  ];

  poleTypes = [
    { label: 'Concrete', value: 'concrete' },
    { label: 'Wooden', value: 'wooden'}
  ];

  mapPoleType: Record<number, string> = {
      [1]: 'Concrete',
      [2]: 'Wooden',
    };

  poleConditions = [
    { label: 'Good', value: 'good' },
    { label: 'Bad', value: 'bad' }
  ];

  validationStatuses = [
    { label: 'Pending', value: 'pending' },
    { label: 'Complete', value: 'complete' },
    { label: 'Rejected', value: 'rejected' },
    { label: 'Assigned', value: 'assigned' }
  ];

  mapValidationStatus: Record<number,string> = {
    [0]: 'Pending',
    [1]: 'Complete',
    [3]: 'Assigned',
    [4]: 'Rejected'
  }

  
  mapDateType: Record<number,string> = {
    [2]: 'Last Update Time',
    [3]: 'Tagged Date',
    [6]: 'Validated Date'
  }

  mapUserType: Record<number, string> = {
    [1]: 'First Captured User',
    [2]: 'Last Captured User',
    [3]: 'Reassigned By',
    [4]: 'Validated By',
    [5]: 'Audited By'
  }

  months = [
    { value: '01', label: 'January' },
    { value: '02', label: 'February' },
    { value: '03', label: 'March' },
    { value: '04', label: 'April' },
    { value: '05', label: 'May' },
    { value: '06', label: 'June' },
    { value: '07', label: 'July' },
    { value: '08', label: 'August' },
    { value: '09', label: 'September' },
    { value: '10', label: 'October' },
    { value: '11', label: 'November' },
    { value: '12', label: 'December' },
  ];

  @Input() filterInput: MvPoleFilter = new MvPoleFilter();
  @Input() appliedFiltersInput: MvPoleAppliedFilter[] = [];

  @Output() close = new EventEmitter<void>();
  @Output() addFilter = new EventEmitter<MvPoleFilter>();
  @Output() addFilterCards = new EventEmitter<{ label: string, value: any }[]>();


  ngOnInit(): void {
    if (this.hasCimDataIntegration) {
      this.getGeographicalRegions();
    } else {
      this.getRegions();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['filterInput']) {
      this.filter = this.filterInput;
    }
    if (changes['appliedFiltersInput']) {
      this.appliedFilters = this.appliedFiltersInput;
      this.selectAppliedFilters();
      this.cdr.detectChanges();
    }
  }

  private selectAppliedFilters(){
    // Areas
    if (this.hasCimDataIntegration) {
      this.selectedSubGeoRegions = this.appliedFilters
        .filter(f => f.label === 'Area')
        .map(f => ({
          id: f.id ?? 0,
          name: f.value
        }));
    } else {
      this.selectedAreas = this.appliedFilters
        .filter(f => f.label === 'Area')
        .map(f => ({
          id: f.id ?? 0,
          name: f.value
        }));
    }

    const searchFilter = this.appliedFilters.find(f => f.label === 'Search');
    if (searchFilter) {
      this.filter.search = searchFilter.value;
    }

    // Users
    this.selectedUsers = this.appliedFilters
    .filter(f => f.label === 'User')
    .map(f => ({
      id: f.id ?? 0,
      name: f.value
    }));

    // User Type      

    // Pole Type
    const selectedType = this.appliedFilters.filter(f => f.label === 'Type')[0]?.value;
    this.selectedPoleType = selectedType?.toLowerCase();
    
    // Status
    const selectedStatus = this.appliedFilters.filter(f => f.label === 'Status')[0]?.value;
    this.selectedValidationStatus = selectedStatus?.toLowerCase();

    // Date From
    const selectedDateFrom = this.appliedFilters.filter(f => f.label === 'Date From')[0]?.value;
    this.selectedDateFrom = selectedDateFrom;

    // Date To
    const selectedDateTo = this.appliedFilters.filter(f => f.label === 'Date To')[0]?.value;
    this.selectedDateTo = selectedDateTo;

    // Date Type
    const selectedDateTypeString = this.appliedFilters.filter(f => f.label === 'Date Type')[0]?.value;
    this.selectedDateTypeString = selectedDateTypeString != undefined ? selectedDateTypeString : 'Last Update Time';
    this.onDateTypeChange();    
  }

  onDateTypeChange() {
    switch(this.selectedDateTypeString) {
      case 'Last Update Time':
        this.selectedDateType = DateType.LastUpdateTime;
        break;
      case 'Tagged Date':
        this.selectedDateType = DateType.TaggedDate;
        break;
      case 'Validated Date':
        this.selectedDateType = DateType.ValidatedDate;
        break;
      default:
        this.selectedDateType = DateType.LastUpdateTime;
        break;
    }
  }

  toggleFilter(filter: string) {
    const index = this.openedFilters.indexOf(filter);
    if (index > -1) {
      this.openedFilters.splice(index, 1); 
    } else {
      this.openedFilters.push(filter);
    }
  }

  onCancel() {
    this.close.emit();
  }

  onWindowClick(event: MouseEvent) {
    event.stopPropagation();
  }

  selectUserType(obj: string | null){
    if ( obj == null || obj == '')
      this.filter.userType = UserType.None;
    else if (obj == 'first')
      this.filter.userType = UserType.FirstCapturedUser;
    else if (obj == 'last')
      this.filter.userType = UserType.LastCapturedUser;
    else if (obj == 'reassigned')
      this.filter.userType = UserType.ReassignedBy;
    else if (obj == 'validated')
      this.filter.userType = UserType.ValidatedBy;
    else if (obj == 'audited')
      this.filter.userType = UserType.AuditedBy;
  }

  selectMvPoleType(obj: string | null){
    if ( obj == null || obj == '')
      this.filter.type = 0;
    else if (obj == 'concrete')
      this.filter.type = 1;
    else if (obj == 'wooden')
      this.filter.type = 2;
  }

  selectMvPoleStatus(obj: string | null){
    if ( obj == null || obj == '')
      this.filter.status = null;
    else if (obj == 'pending')
      this.filter.status = 0;
    else if (obj == 'complete')
      this.filter.status = 1;
    else if (obj == 'rejected')
      this.filter.status = 4;
    else if (obj == 'assigned')
      this.filter.status = 3;
  }

  onSelectUserType(option: {label: string, value: string}){
    this.selectUserType(option.value);
    this.getUsersForFilter(this.filter);
  }

  onSelectUser(user: {id: number, name: string}, event: Event){
    const isChecked = (event.target as HTMLInputElement).checked;
    if (isChecked) {
      this.selectedUsers.push({id: user.id, name: user.name});
    } else {
      this.selectedUsers = this.selectedUsers.filter(u => u.id !== user.id);
    }
  }

  isUserSelected(user: {id: number, name: string}): boolean {
    return this.selectedUsers.some(u => u.id === user.id);
  }

  get filteredUsers() {
  if (!this.searchUsersText?.trim()) {
    return this.allUsers;
  }

  return this.allUsers.filter(user =>
    user.name.toLowerCase().includes(this.searchUsersText.toLowerCase())
  );
}

  getUsersForFilter(filterObject?: any) {
    if (
      filterObject.userType == UserType.FirstCapturedUser ||
      filterObject.userType == UserType.LastCapturedUser
    ) {
      this.userService.getUsersForFilter(SystemComponents.Mobile)
      .subscribe((res) => {
        this.allUsers = res.data;
      })
    } else {
      this.userService.getUsersForFilter(SystemComponents.Admin)
      .subscribe((res) => {
        this.allUsers = res.data;
      })
    }
  }

  createFilterCards(filter: MvPoleFilter){
    this.appliedFilters = [];

    if(filter.search != null && filter.search != '')
      this.appliedFilters.push({label: 'Search', value: filter.search})
    
    if(filter.filterBy != null && filter.filterBy != '')
      this.appliedFilters.push({label: 'Filter By', value: filter.filterBy})

    if(filter.userType != null && filter.userType != UserType.None)
      this.appliedFilters.push({label: 'User Type', value: this.mapUserType[filter.userType]})

    if(filter.type != null && filter.type != 0)
      this.appliedFilters.push({label: 'Type', value: this.mapPoleType[filter.type]})

    if(filter.status != null)
      this.appliedFilters.push({label: 'Status', value: this.mapValidationStatus[filter.status]})

    if(filter.dateFrom != null && filter.dateFrom != '')
      this.appliedFilters.push({label:'Date From', value: filter.dateFrom})

    if(filter.dateTo != null && filter.dateTo != '')
      this.appliedFilters.push({label:'Date To', value: filter.dateTo})

    if(filter.dateType != null && filter.dateType != DateType.LastUpdateTime)
      this.appliedFilters.push({label:'Date Type', value: this.mapDateType[filter.dateType]})

    if (this.hasCimDataIntegration) {
      if (filter.selectedSubGeographicalRegions != null && filter.selectedSubGeographicalRegions.length > 0) {
        const selectedSubGeo = this.selectedSubGeoRegions
          .filter(sub => filter.selectedSubGeographicalRegions.includes(sub.id))
          .map(sub => ({ id: sub.id, name: sub.name }));

        selectedSubGeo.forEach(sub => {
          const alreadyExists = this.appliedFilters.some(
            f => f.id === sub.id && f.label === 'Area'
          );

          if (!alreadyExists) {
            this.appliedFilters.push({ id: sub.id, label: 'Area', value: sub.name });
          }
        });
      }
    } else if (filter.selectedAreas != null && filter.selectedAreas.length > 0) {
      const selectedArea = this.selectedAreas
        .filter(area => filter.selectedAreas.includes(area.id))
        .map(area => ({ id: area.id, name: area.name }));

      selectedArea.forEach(area => {
        const alreadyExists = this.appliedFilters.some(
          f => f.id === area.id && f.label === 'Area'
        );

        if (!alreadyExists) {
          this.appliedFilters.push({ id: area.id, label: 'Area', value: area.name });
        }
      });
    }

    if (filter.selectedUsers != null && filter.selectedUsers.length > 0) {
      const selectedUser = this.selectedUsers
        .filter(user => filter.selectedUsers.includes(user.id))
        .map(user => ({ id: user.id, name: user.name }));

      selectedUser.forEach(user => {
        const alreadyExists = this.appliedFilters.some(
          f => f.id === user.id && f.label === 'User'
        );

        if (!alreadyExists) {
          this.appliedFilters.push({ id: user.id, label: 'User', value: user.name });
        }
      });
    }

    this.addFilterCards.emit(this.appliedFilters);
  }

  onAddFilter() {
    this.filter.filterBy = '';
    this.selectUserType(this.selectedUserType);
    this.selectMvPoleType(this.selectedPoleType);
    this.selectMvPoleStatus(this.selectedValidationStatus)
    this.filter.sortBy = SortType.NEWEST;
    this.filter.dateFrom = this.selectedDateFrom ?? null;
    this.filter.dateTo = this.selectedDateTo ?? null;
    this.filter.dateType = this.selectedDateType;
    if (this.hasCimDataIntegration) {
      this.filter.selectedSubGeographicalRegions = this.selectedSubGeoRegions.length > 0 ? this.selectedSubGeoRegions.map(sub => sub.id) : [];
      this.filter.selectedAreas = [];
    } else {
      this.filter.selectedAreas = this.selectedAreas.length > 0 ? this.selectedAreas.map(area => area.id) : [];
      this.filter.selectedSubGeographicalRegions = [];
    }
    this.filter.selectedIds = [];
    this.filter.selectedUsers = this.selectedUsers.length > 0 ? this.selectedUsers.map(u => u.id) : [];
    this.addFilter.emit(this.filter);
    this.createFilterCards(this.filter);
    this.onCancel();
  }

  selectRegion(region: Region) {
    this.selectedRegion = this.selectedRegion === region ? null : region;
    this.updateAreas();
  }

  updateAreas() {
    this.areas = this.allAreas.filter(
      (area) =>
        (!this.selectedRegion || area.regionId === this.selectedRegion.id) &&
        (!this.districtSearchText ||
          area.name.toLowerCase().includes(this.districtSearchText.toLowerCase()))
    );
  }

  get filteredRegions() {
    return this.regions.filter(
      (region) =>
        !this.regionSearchText ||
        region.name.toLowerCase().includes(this.regionSearchText.toLowerCase())
    );
  }

  isAreaSelected(area: {id: number, name: string}): boolean{
    return this.selectedAreas.some(a => a.id == area.id);
  }

  onAreaSelect(area: {id: number, name: string}, event: Event){
    const isChecked = (event.target as HTMLInputElement).checked;
    if (isChecked) {
      this.selectedAreas.push({id: area.id, name: area.name});
    } else {
      this.selectedAreas = this.selectedAreas.filter(u => u.id !== area.id);
    }
  }

  private getRegions() {
    this.regionService.getAllForSelect().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.regions = responseData.data.map((region: Region) => ({
            ...region,
            isExpanded: false,
          }));
          this.getAreas();
        } else if (response?.status === 204) {
          this.regions = [];
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred');
      },
    });
  }

  private getAreas() {
    this.areaService.getAllForSelect().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.allAreas = responseData.data.map((area: Area) => ({
            ...area,
            checked: false,
          }));
          this.updateAreas();
        } else if (response?.status === 204) {
          this.allAreas = [];
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred');
      },
    });
  }

  selectGeographicalRegion(region: GeographicalRegion) {
    this.selectedGeographicalRegion = this.selectedGeographicalRegion === region ? null : region;
    this.updateSubGeographicalRegions();
  }

  updateSubGeographicalRegions() {
    this.subGeographicalRegions = this.allSubGeographicalRegions.filter(
      (sub) =>
        (!this.selectedGeographicalRegion || sub.geographicalRegion?.id === this.selectedGeographicalRegion.id) &&
        (!this.districtSearchText ||
          sub.name.toLowerCase().includes(this.districtSearchText.toLowerCase()))
    );
  }

  get filteredGeographicalRegions() {
    return this.geographicalRegions.filter(
      (region) =>
        !this.regionSearchText ||
        region.name.toLowerCase().includes(this.regionSearchText.toLowerCase())
    );
  }

  isSubGeoSelected(sub: {id: number, name: string}): boolean {
    return this.selectedSubGeoRegions.some(s => s.id === sub.id);
  }

  onSubGeoSelect(sub: {id: number, name: string}, event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    if (isChecked) {
      this.selectedSubGeoRegions.push({id: sub.id, name: sub.name});
    } else {
      this.selectedSubGeoRegions = this.selectedSubGeoRegions.filter(s => s.id !== sub.id);
    }
  }

  private getGeographicalRegions() {
    this.geographicalRegionService.getAllForSelect().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.geographicalRegions = responseData.data;
          this.getSubGeographicalRegions();
        } else if (response?.status === 204) {
          this.geographicalRegions = [];
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred');
      },
    });
  }

  private getSubGeographicalRegions() {
    this.subGeographicalRegionService.getAllForMappings().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.allSubGeographicalRegions = responseData.data;
          this.updateSubGeographicalRegions();
        } else if (response?.status === 204) {
          this.allSubGeographicalRegions = [];
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred');
      },
    });
  }
}